import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=7b45a690&scoped=true&"
import script from "./CRUD.vue?vue&type=script&lang=ts&"
export * from "./CRUD.vue?vue&type=script&lang=ts&"
import style0 from "./CRUD.vue?vue&type=style&index=0&id=7b45a690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45a690",
  null
  
)

export default component.exports